<template>
  <main class="artist-detail detail" role="main">
    <header-details :details="company" :type="'company'" />
    <section-nav
      :sections="sectionsNav"
      :have-description="haveDescription()"
      :have-gallery="haveGallery()"
      :have-events="haveEvents()"
      :have-artists="haveArtists()"
      class="d-none d-md-block"
    />
    <b-container class="detail-container">
      <sign-banner v-if="!$store.state.auth.userIsAuthenticated && !buyer" />
      <concerts-list
        v-if="company.show_events"
        id="events"
        :name="company.name"
        :type="'company'"
        :user="company.user"
        :element-id="company.id"
      />
      <information
        v-if="company.description || company.links || program"
        id="info"
        :description="company.description"
        :links="company.links"
        :program="program"
      />
      <gallery
        v-if="gallery && gallery.length > 0"
        id="gallery"
        :gallery="gallery"
      />
      <aside>
        <artists-event
          v-if="
            company.show_artists &&
              artists.artists &&
              artists.artists.length > 0
          "
          id="artists"
          :artists-event="artists.artists"
        />
        <venues-event
          v-if="
            company.show_venues && venues.venues && venues.venues.length > 0
          "
          :venues-event="venues"
        />
      </aside>

      <fb-pixel
        v-if="company.facebook_pixel_js"
        :fb-pixel="company.facebook_pixel_js"
      />
      <ga-pixel
        v-if="company.google_pixel_js"
        :ga-pixel="company.google_pixel_js"
      />
    </b-container>
  </main>
</template>

<script>
import HeaderDetails from '@/components/header-details/HeaderDetails.vue'
import SectionNav from '@/components/section-nav/SectionNav.vue'
import ConcertsList from '@/components/concerts-list/ConcertsList.vue'
import Information from '@/components/information/Information.vue'
import ArtistsEvent from '@/components/artists-event/ArtistsEvent.vue'
import VenuesEvent from '@/components/venues-event/VenuesEvent.vue'
import Gallery from '@/components/gallery/Gallery.vue'
import FbPixel from '@/components/pixels/FbPixel.vue'
import GaPixel from '@/components/pixels/GaPixel.vue'
import SignBanner from '@/components/sign-banner/SignBanner.vue'

export default {
  components: {
    HeaderDetails,
    SectionNav,
    ConcertsList,
    Information,
    SignBanner,
    ArtistsEvent,
    VenuesEvent,
    Gallery,
    FbPixel,
    GaPixel
  },
  data: () => ({
    sectionsNav: [
      {
        id: 'events',
        text: 'oficialProfiles.conciertos'
      },
      {
        id: 'info',
        text: 'oficialProfiles.info'
      },
      {
        id: 'gallery',
        text: 'oficialProfiles.galeria'
      },
      {
        id: 'artists',
        text: 'oficialProfiles.artistas'
      }
    ],
    openChat: false,
    adultAdvisor: false,
    buyer: process.env.VUE_APP_BUYER === 'true'
  }),
  computed: {
    company() {
      return this.$store.state.company.detail
    },
    gallery() {
      return this.$store.state.gallery.list
    },
    artists() {
      return []
      // return this.$store.state.artist.list
    },
    program() {
      return []
      // return this.$store.state.gallery.program
    },
    venues() {
      return []
      // return this.$store.state.venue.list
    },
  },
  async mounted() {
    await this.$store.dispatch('gallery/getProgram')
    await this.$store.dispatch('gallery/getGallery')
    this.$ga.page({
      page: window.location.pathname,
      title: this.$store.state.company.detail.name,
      location: window.location.href
    })
    if (this.$store.state.company.detail.id) {
      if (typeof window.fbq !== 'undefined') {
        window.fbq('track', 'ViewContent', {
          content_ids: [this.$store.state.company.detail.id],
          content_name: this.$store.state.company.detail.name
        })
      }
    }
    this.$root.$on('openAdultAdvisor', event => {
      this.adultAdvisor = true
    })
    this.$root.$on('closeAdultAdvisor', () => {
      this.adultAdvisor = false
    })
    if (this.company.restricted) {
      this.$root.$emit('openAdultAdvisor')
    }
  },
  methods: {
    haveDescription() {
      if (
        this.$store.state.company.detail &&
        (this.$store.state.company.detail.description ||
          this.$store.state.company.detail.links ||
          this.$store.state.gallery.program)
      )
        return true
      return false
    },
    haveGallery() {
      if (
        this.$store.state.gallery.list &&
        this.$store.state.gallery.list.length > 0
      )
        return true
      return false
    },
    haveEvents() {
      if (
        this.$store.state.company.detail &&
        this.$store.state.company.detail.show_events &&
        this.$store.state.company.detail.events.length > 0
      )
        return true
      return false
    },
    haveArtists() {
      if (
        this.$store.state.company.detail &&
        this.$store.state.company.detail.show_artists &&
        this.$store.state.artist &&
        this.$store.state.artist.list &&
        this.$store.state.artist.list.artists &&
        this.$store.state.artist.list.artists.length > 0
      )
        return true
      return false
    },
  },
}
</script>
